import { MESApiService } from "@dexteel/mesf-core";
import { get } from "lodash-es";

// Per-parameter configuration rows served by MILL.GetStraightenerParameters:
// grouping, flags (sendToPlc / isRequired / readOnly / rollCount) and the
// validation limits (min / max) edited from Configuration > Straightener.
export interface StraightenerParameterConfig {
	Id: number;
	Code: string;
	Name: string;
	GroupCode: string;
	SortOrder: number;
	RollCount: number;
	HasMinMax: boolean;
	SendToPlc: boolean;
	IsRequired: boolean;
	IsReadOnly: boolean;
	ValueType: string;
	IsProductDim: boolean;
	MinValue: number | null;
	MaxValue: number | null;
	ModifiedBy: string | null;
	ModifiedAt: string | null;
}

export const fetchStraightenerParameters = async (): Promise<
	StraightenerParameterConfig[]
> => {
	const api = new MESApiService();
	const resp = await api.callV2("[MILL].[GetStraightenerParameters]", []);
	if (resp.ok) {
		return get(
			resp,
			"data.tables[0].rows",
			[],
		) as StraightenerParameterConfig[];
	}
	throw new Error(resp.message || "Error fetching straightener parameters");
};
